module.exports = __webpack_public_path__ + "img/stars-demo.77add74b.svg";